import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const scenarioRuleSet = api(async function scenarioRuleSet({ scenarioId }) {
    return query(
        gql`
            query GetScenarioRuleSet($scenarioId: String!) {
                scenarioRuleSet(scenarioId: $scenarioId) {
                    id
                    scenarioId
                    name
                    description
                    defaultAction
                    rules {
                        id
                        name
                        justification
                        conditions {
                            field
                            operator
                            value
                        }
                        action {
                            type
                            multiplier
                            costKind
                            fixedAmount
                            timeKind
                            timeValue
                            frequencyMultiplier
                        }
                    }
                    created
                    modified
                }
            }
        `,
        { scenarioId },
        { returns: "scenarioRuleSet" }
    )
})
